<app-master *ngIf="!isResponsive">
  <router-outlet></router-outlet>
</app-master>
<menu-responsivo *ngIf="isResponsive">
  <router-outlet></router-outlet>
</menu-responsivo>
